export const ActionTypeBlog = {
	// Articles
	GET_BLOG_ARTICLES_BEGIN: "GET_BLOG_ARTICLES_BEGIN",
	GET_BLOG_ARTICLES_SUCCESS: "GET_BLOG_ARTICLES_SUCCESS",
	GET_BLOG_ARTICLES_ERROR: "GET_BLOG_ARTICLES_ERROR",
	ADD_EDIT_BLOG_ARTICLE_BEGIN: "ADD_EDIT_BLOG_ARTICLE_BEGIN",
	ADD_EDIT_BLOG_ARTICLE_SUCCESS: "ADD_EDIT_BLOG_ARTICLE_SUCCESS",
	ADD_EDIT_BLOG_ARTICLE_ERROR: "ADD_EDIT_BLOG_ARTICLE_ERROR",
	EDIT_BLOG_ARTICLE_BEGIN: "EDIT_BLOG_ARTICLE_BEGIN",
	EDIT_BLOG_ARTICLE_SUCCESS: "EDIT_BLOG_ARTICLE_SUCCESS",
	EDIT_BLOG_ARTICLE_ERROR: "EDIT_BLOG_ARTICLE_ERROR",
	DELETE_BLOG_ARTICLE_BEGIN: "DELETE_BLOG_ARTICLE_BEGIN",
	DELETE_BLOG_ARTICLE_SUCCESS: "DELETE_BLOG_ARTICLE_SUCCESS",
	DELETE_BLOG_ARTICLE_ERROR: "DELETE_BLOG_ARTICLE_ERROR",

	// Categories
	GET_BLOG_CATEGORIES_BEGIN: "GET_BLOG_CATEGORIES_BEGIN",
	GET_BLOG_CATEGORIES_SUCCESS: "GET_BLOG_CATEGORIES_SUCCESS",
	GET_BLOG_CATEGORIES_ERROR: "GET_BLOG_CATEGORIES_ERROR",
	ADD_BLOG_CATEGORY_BEGIN: "ADD_BLOG_CATEGORY_BEGIN",
	ADD_BLOG_CATEGORY_SUCCESS: "ADD_BLOG_CATEGORY_SUCCESS",
	ADD_BLOG_CATEGORY_ERROR: "ADD_BLOG_CATEGORY_ERROR",
	EDIT_BLOG_CATEGORY_BEGIN: "EDIT_BLOG_CATEGORY_BEGIN",
	EDIT_BLOG_CATEGORY_SUCCESS: "EDIT_BLOG_CATEGORY_SUCCESS",
	EDIT_BLOG_CATEGORY_ERROR: "EDIT_BLOG_CATEGORY_ERROR",
	DELETE_BLOG_CATEGORY_BEGIN: "DELETE_BLOG_CATEGORY_BEGIN",
	DELETE_BLOG_CATEGORY_SUCCESS: "DELETE_BLOG_CATEGORY_SUCCESS",
	DELETE_BLOG_CATEGORY_ERROR: "DELETE_BLOG_CATEGORY_ERROR",
	CHANGE_BLOG_CATEGORY_VISIBILITY_BEGIN: "CHANGE_BLOG_CATEGORY_VISIBILITY_BEGIN",
	CHANGE_BLOG_CATEGORY_VISIBILITY_ERROR: "CHANGE_BLOG_CATEGORY_VISIBILITY_ERROR",
	CHANGE_BLOG_CATEGORY_VISIBILITY_SUCCESS: "CHANGE_BLOG_CATEGORY_VISIBILITY_SUCCESS",
	GET_BLOG_CATEGORY_ICONS_BEGIN: "GET_BLOG_CATEGORY_ICONS_BEGIN",
	GET_BLOG_CATEGORY_ICONS_ERROR: "GET_BLOG_CATEGORY_ICONS_ERROR",
	GET_BLOG_CATEGORY_ICONS_SUCCESS: "GET_BLOG_CATEGORY_ICONS_SUCCESS",
	GET_BLOG_CATEGORY_ICON_VISIBILITY_BEGIN: "GET_BLOG_CATEGORY_ICON_VISIBILITY_BEGIN",
	GET_BLOG_CATEGORY_ICON_VISIBILITY_ERROR: "GET_BLOG_CATEGORY_ICON_VISIBILITY_ERROR",
	GET_BLOG_CATEGORY_ICON_VISIBILITY_SUCCESS: "GET_BLOG_CATEGORY_ICON_VISIBILITY_SUCCESS",
	CHANGE_BLOG_CATEGORY_ICON_VISIBILITY_BEGIN: "CHANGE_BLOG_CATEGORY_ICON_VISIBILITY_BEGIN",
	CHANGE_BLOG_CATEGORY_ICON_VISIBILITY_ERROR: "CHANGE_BLOG_CATEGORY_ICON_VISIBILITY_ERROR",
	CHANGE_BLOG_CATEGORY_ICON_VISIBILITY_SUCCESS: "CHANGE_BLOG_CATEGORY_ICON_VISIBILITY_SUCCESS",
	MOVE_BLOG_CATEGORY_BEGIN: "MOVE_BLOG_CATEGORY_BEGIN",
	MOVE_BLOG_CATEGORY_ERROR: "MOVE_BLOG_CATEGORY_ERROR",
	MOVE_BLOG_CATEGORY_SUCCESS: "MOVE_BLOG_CATEGORY_SUCCESS",

	// Settings
	GET_BLOG_SETTINGS_BEGIN: "GET_BLOG_SETTINGS_BEGIN",
	GET_BLOG_SETTINGS_SUCCESS: "GET_BLOG_SETTINGS_SUCCESS",
	GET_BLOG_SETTINGS_ERROR: "GET_BLOG_SETTINGS_ERROR",
	SET_BLOG_SETTINGS_BEGIN: "SET_BLOG_SETTINGS_BEGIN",
	SET_BLOG_SETTINGS_SUCCESS: "SET_BLOG_SETTINGS_SUCCESS",
	SET_BLOG_SETTINGS_ERROR: "SET_BLOG_SETTINGS_ERROR",

	// Visibility
	CHANGE_BLOG_ARTICLE_VISIBILITY_BEGIN: "CHANGE_BLOG_ARTICLE_VISIBILITY_BEGIN",
	CHANGE_BLOG_ARTICLE_VISIBILITY_ERROR: "CHANGE_BLOG_ARTICLE_VISIBILITY_ERROR",
	CHANGE_BLOG_ARTICLE_VISIBILITY_SUCCESS: "CHANGE_BLOG_ARTICLE_VISIBILITY_SUCCESS",

	// HighLighting
	HIGHLIGHT_BLOG_ARTICLE_BEGIN: "HIGHLIGHT_BLOG_ARTICLE_BEGIN",
	HIGHLIGHT_BLOG_ARTICLE_SUCCESS: "HIGHLIGHT_BLOG_ARTICLE_SUCCESS",
	HIGHLIGHT_BLOG_ARTICLE_ERROR: "HIGHLIGHT_BLOG_ARTICLE_ERROR",
};
